import { render } from "./IconLogotype.vue?vue&type=template&id=5c829068&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconLogotype.vue?vue&type=script&lang=js"
export * from "./IconLogotype.vue?vue&type=script&lang=js"
script.render = render

export default script